







import { Component, Vue, Prop } from 'vue-property-decorator';
import RootProjectsList from '@/components/RootProjectsList.vue'
import NotLoggedPanel from '@/components/NotLoggedPanel.vue';
import { User } from '@/models/user';

@Component({
    name: 'RootProjects',
    components: {
        RootProjectsList,
        NotLoggedPanel
    }
})
export default class RootProjects extends Vue {
    @Prop() private user!: User;
}
